<template>
  <div>
    <a-modal
      v-model="visible"
      title="Google验证码验证"
      :confirmLoading="loading"
      @ok="handleOk"
      @cancel="handleCancel"
      :maskClosable="false"
      width="400px"
    >
      <div class="google-verify-content">
        <div class="verify-tips">
          <a-icon type="safety-certificate" style="color: #1890ff; margin-right: 8px;" />
          <span>请输入您的6位Google验证码</span>
        </div>

        <a-form-model
          ref="form"
          :model="formData"
          :rules="rules"
          :label-col="{ span: 0 }"
          :wrapper-col="{ span: 24 }"
        >
          <a-form-model-item prop="code">
            <a-input
              v-model="formData.code"
              placeholder="请输入6位Google验证码"
              :maxLength="6"
              class="google-code-input"
              @pressEnter="handleOk"
              ref="codeInput"
            />
          </a-form-model-item>
        </a-form-model>

        <div class="verify-notes">
          <p>• 验证码为6位数字</p>
          <p>• 验证码每30秒更新一次</p>
          <p>• 请确保手机时间准确</p>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { checkGoogleCode } from '@/api/login'
export default {
  name: 'GoogleModal',
  data () {
    return {
      visible: false,
      loading: false,
      formData: {
        code: ''
      },
      rules: {
        code: [
          { required: true, message: '请输入Google验证码', trigger: 'blur' },
          {
            pattern: /^\d{6}$/,
            message: '验证码必须为6位数字',
            trigger: 'blur'
          }
        ]
      },
      resolve: null, // Promise resolve
      reject: null // Promise reject
    }
  },
  methods: {
    // 显示弹框
    show () {
      return new Promise((resolve, reject) => {
        this.visible = true
        this.resolve = resolve
        this.reject = reject
        this.resetForm()
        // 自动聚焦到输入框
        this.$nextTick(() => {
          if (this.$refs.codeInput) {
            this.$refs.codeInput.focus()
          }
        })
      })
    },

    // 确认操作
    async handleOk () {
      try {
        // 表单验证
        await this.$refs.form.validate()

        this.loading = true

        // 这里可以添加实际的验证码验证逻辑
        // 例如调用API验证验证码是否正确
        const res = await checkGoogleCode(this.formData.code)
        console.log('res', res)

        // 模拟验证过程
        // await this.sleep(500)

        // 验证成功，返回验证码
        // if (this.resolve) {
        //   this.resolve({
        //     success: true,
        //     code: this.formData.code
        //   })
        // }

        this.visible = false
        this.resolve({
            success: true,
            code: this.formData.code
        })
        this.$message.success('验证码验证成功')
      } catch (error) {
        // console.error('Google验证码验证失败:', error)
        // 如果是表单验证错误，不显示错误消息
         // 其他错误情况
         this.$message.error('验证码验证失败，请重试')
         this.reject({
            success: false,
            message: '验证码验证失败'
          })
        if (error && error.errorFields) {
          return
        }
      } finally {
        this.loading = false
      }
    },

    // 取消操作
    handleCancel () {
      this.visible = false
      if (this.reject) {
        this.reject({
          success: false,
          message: '用户取消操作'
        })
      }
    },

    // 重置表单
    resetForm () {
      this.formData = {
        code: ''
      }
      this.loading = false

      // 清除表单验证
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    },

    // 辅助方法：延迟
    sleep (ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    }
  },

  // 组件销毁时清理
  beforeDestroy () {
    if (this.reject) {
      this.reject({
        success: false,
        message: '组件已销毁'
      })
    }
  }
}
</script>

<style lang="less" scoped>
.google-verify-content {
  padding: 16px 0;

  .verify-tips {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    padding: 12px 16px;
    background-color: #f6ffed;
    border: 1px solid #b7eb8f;
    border-radius: 6px;
    color: #52c41a;
    font-size: 14px;
  }

  .google-code-input {
    font-size: 18px;
    text-align: center;
    letter-spacing: 4px;
    font-weight: 500;

    /deep/ .ant-input {
      text-align: center;
      font-size: 18px;
      letter-spacing: 4px;
      font-weight: 500;
      height: 48px;
    }
  }

  .verify-notes {
    margin-top: 16px;
    padding: 12px 16px;
    background-color: #fafafa;
    border-radius: 6px;

    p {
      margin: 4px 0;
      font-size: 12px;
      color: #666;
      line-height: 1.4;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
